import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import AppRouter from "./AppRouter";
import { AuthProvider } from "./contexts/AuthContext";
import { initializeErrorTracking } from "./services/errorLogApi";
import ErrorBoundary from "./components/ErrorBoundary";

// Initialize global error tracking
initializeErrorTracking();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
